import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6150adee&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6150adee')) {
      api.createRecord('6150adee', component.options)
    } else {
      api.reload('6150adee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6150adee&", function () {
      api.rerender('6150adee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/regions/index.vue"
export default component.exports